import { Link, useLocation } from "react-router-dom";

const items = [
  { label: "首页", to: "/", icon: "ri-home-5-line", activeIcon: "ri-home-5-fill" },
  { label: "分类", to: "/category/hot-blood", icon: "ri-apps-2-line", activeIcon: "ri-apps-2-fill" },
  { label: "搜索", to: "/search", icon: "ri-search-line", activeIcon: "ri-search-line" },
  { label: "收藏", to: "/favorites", icon: "ri-heart-3-line", activeIcon: "ri-heart-3-fill" },
];

export default function MobileBottomNav() {
  const location = useLocation();

  const isActive = (to: string) => {
    if (to === "/") return location.pathname === "/";
    const base = to.split("/").filter(Boolean)[0];
    return base ? location.pathname.startsWith(`/${base}`) : false;
  };

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background-50/95 backdrop-blur border-t border-background-200/80">
      <div className="grid grid-cols-4">
        {items.map((item) => {
          const active = isActive(item.to);
          return (
            <Link
              key={item.to}
              to={item.to}
              className={`flex flex-col items-center justify-center gap-0.5 py-2.5 text-[11px] ${
                active ? "text-primary-600 font-medium" : "text-foreground-500"
              }`}
            >
              <i className={`${active ? item.activeIcon : item.icon} text-xl`} />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}